import { Reducer } from 'redux';
import { DetailsPanelActionTypes, DetailsPanelState } from './types';

export const initialState: DetailsPanelState = {
  enquiryDetails: undefined,
  isLoadingEnquiryDetails: false,
  combinedPDFDownloadURL: undefined,
  isDownloadingCombinedPDF: false,
  combinedZIPDownloadData: undefined,
  isDownloadingCombinedZIP: false
};

const reducer: Reducer<DetailsPanelState> = (
  state = initialState,
  action: any
) => {
  switch (action.type) {
    case DetailsPanelActionTypes.GET_ENQUIRY_DETAILS_START: {
      return {
        ...state,
        isLoadingEnquiryDetails: true,
        enquiryDetails: undefined,
        enquiryReferrals: []
      };
    }
    case DetailsPanelActionTypes.GET_ENQUIRY_DETAILS_SUCCESS: {
      return {
        ...state,
        isLoadingEnquiryDetails: false,
        enquiryDetails: action.payload
      };
    }
    case DetailsPanelActionTypes.GET_ENQUIRY_DETAILS_FAILURE: {
      return {
        ...state,
        isLoadingEnquiryDetails: false,
        enquiryDetails: action.payload
      };
    }
    case DetailsPanelActionTypes.DOWNLOAD_COMBINED_PDF_START: {
      return {
        ...state,
        isDownloadingCombinedPDF: true,
        combinedPDFDownloadURL: undefined
      };
    }
    case DetailsPanelActionTypes.DOWNLOAD_COMBINED_PDF_SUCCESS: {
      return {
        ...state,
        isDownloadingCombinedPDF: false,
        combinedPDFDownloadURL: action.payload
      };
    }
    case DetailsPanelActionTypes.DOWNLOAD_COMBINED_PDF_FAILURE: {
      return {
        ...state,
        isDownloadingCombinedPDF: false,
        combinedPDFDownloadURL: undefined
      };
    }
    case DetailsPanelActionTypes.DOWNLOAD_COMBINED_ZIP_START: {
      return {
        ...state,
        isDownloadingCombinedZIP: true,
        combinedZIPDownloadData: undefined
      };
    }
    case DetailsPanelActionTypes.DOWNLOAD_COMBINED_ZIP_SUCCESS: {
      const { combinedZIPDownloadData } = state;
      return {
        ...state,
        isDownloadingCombinedZIP: false,
        combinedZIPDownloadData: {
          ...combinedZIPDownloadData,
          blobData: action.payload.blobData,
          fileName: action.payload.fileName
        }
      };
    }
    case DetailsPanelActionTypes.DOWNLOAD_COMBINED_ZIP_FAILURE: {
      return {
        ...state,
        isDownloadingCombinedZIP: false,
        combinedZIPDownloadData: undefined
      };
    }
    default:
      return state;
  }
};

export default reducer;
